import { ResponsiveLine } from '@nivo/line';
import React from 'react';

import { TooltipContent } from '~/views/audiences/AudiencePage/Tabs/OverviewPage/components/PointTooltip/PointTooltip.styles';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { LineChartBlock } from './blockTypes';

interface Props {
  block: LineChartBlock;
}

const SimpleLineChart = ({ block }: Props) => {
  const data = [{ id: block.title, data: block.data.map((d) => ({ x: d.x, y: d.y })) }];

  return (
    <div>
      <ChartTitle>{block.title}</ChartTitle>
      <ChartWrapper>
        <ResponsiveLine
          data={data}
          margin={{ top: 20, right: 20, bottom: 50, left: 60 }}
          axisBottom={{ legend: block.xLabel, legendPosition: 'middle', legendOffset: 36 }}
          axisLeft={{ legend: block.yLabel, legendPosition: 'middle', legendOffset: -50 }}
          enablePoints={true}
          pointSize={8}
          useMesh={true}
          animate={true}
          tooltip={({ point }) => (
            <TooltipContent>{`${point.data.xFormatted as string}: ${point.data.yFormatted as string}`}</TooltipContent>
          )}
          colors={['#f97316']}
          pointColor="#ffffff"
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          theme={{
            axis: {
              ticks: { text: { fontSize: 11, fill: '#6b7280' } },
              legend: { text: { fontSize: 11, fill: '#6b7280' } },
            },
            grid: { line: { stroke: '#f3f4f6' } },
          }}
        />
      </ChartWrapper>
    </div>
  );
};

export default SimpleLineChart;
